import { Typography } from '@/components/ui/Text';
import { assetUrl } from '@/lib/directus/assetUrl';
import clsx from 'clsx';
import Image from 'next/image';
import React, { PropsWithChildren } from 'react';
import { TBlogModuleSplit } from '../../blog/blog.types';

import './BlogArticleModuleSplit.scss';

type Props = {
  module: TBlogModuleSplit;
  mobile?: boolean;
};

const Wrapper: React.FC<PropsWithChildren & { mobile: boolean }> = ({
  children,
  mobile = false,
}) => {
  if (mobile) {
    return <div className='BlogArticleModuleSplit--mobile'>{children}</div>;
  }

  return <div className='BlogArticleModuleSplit--desktop'>{children}</div>;
};

export const BlogArticleModuleSplit: React.FC<Props> = ({
  module,
  mobile = false,
}) => {
  const imgSrc = assetUrl(module.displayImage);

  const contentPart = (
    <div
      className={clsx('BlogArticleModuleSplit__content', {
        'BlogArticleModuleSplit__content--mobile': mobile,
        'BlogArticleModuleSplit__content--desktop': !mobile,
      })}
      dangerouslySetInnerHTML={{ __html: module.description }}
    />
  );

  return (
    <Wrapper mobile={mobile}>
      {module.imageFirst && contentPart}

      <div className='BlogArticleModuleSplit__secondary-content'>
        <div
          className={clsx('BlogArticleModuleSplit__image-container', {
            'BlogArticleModuleSplit__image-container--mobile': mobile,
            'BlogArticleModuleSplit__image-container--desktop': !mobile,
          })}
        >
          {imgSrc && (
            <Image
              src={imgSrc}
              className='BlogArticleModuleSplit__image'
              alt='small promo'
              fill
            />
          )}
        </div>

        {module.subtitle && (
          <div className='BlogArticleModuleSplit__subtitle-container'>
            <Typography
              className='BlogArticleModuleSplit__subtitle'
              variant='body'
            >
              {module.subtitle}
            </Typography>
          </div>
        )}
      </div>

      {!module.imageFirst && contentPart}
    </Wrapper>
  );
};
